import React, {Fragment} from 'react';
import SearchMovie from './components/FormBuscador';
import './App.css';

function App() {
  return (
    <Fragment>
      <div className="container">
        <h1 className="title">Busca Cine React App</h1>
        <SearchMovie />
      </div>
    </Fragment>
  );
}

export default App;
